import ParametersDataTable from "../../../components/dataTable/tables/ParametersDataTable";

function ParametersPageView() {
  return <ParametersDataTable />;
}

export default ParametersPageView;
